export default {
  formFieldName: 'url',
  errors: {
    UnreachableURL: "The resource couldn't be reached",
    ConnectionTimeout: "The resource couldn't be reached",
  },
};
